/**
 * Created by Rodrigo Quesada on 16/01/17.
 */
import {Injectable} from '@angular/core';
import {RepeatableUserModelScreensManager} from '../../../../../components/sections/repeatable/repeatable-user-model-screens-manager.service';
import {RepeatableScreensManagerDeps} from '../../../../shared/step/repeatable-screen-manager.class';
import {Observable} from 'rxjs';
import {ProfessionalLicenseService} from '../../../../../domain/model/licenses-certifications/professional/professional-license.service';

@Injectable()
export class ProfessionalLicenseScreensManager extends RepeatableUserModelScreensManager {

    constructor(rsmm: RepeatableScreensManagerDeps, protected readonly _modelService: ProfessionalLicenseService) {
        super(rsmm);
    }

    navigateToPreviousScreenFrom(index: number): Observable<boolean> {
        this.itemIndex = index;
        return this.navigateToPreviousScreen();
    }

    navigateToNextScreenFrom(index: number): Observable<boolean> {
        this.itemIndex = index;
        return this.navigateToNextScreen();
    }

    navigateToScreen(index: number): Observable<boolean> { return this._navigate(index); }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/licenses-certifications/steps/professional/professional-license/professional-license-screens-manager.service.ts